import React, { memo } from 'react';
import classNames from 'classnames';

import './Tab.scss';

type OnChange = (id: string | number) => void;

export interface TabProps {
  isActive?: boolean;
  isBlue?: boolean;
  tabId: string | number;
  onChange?: OnChange;
  children: React.ReactNode;
  hidden?: boolean;
}

const Tab = ({ children, onChange = id => true, tabId, isActive = false, isBlue = false, hidden = false }: TabProps) => {

  if (hidden) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return <div
    styleName={
      classNames(
        ['tab'],
        {
          'tab--active': isActive,
          'tab--blue': isBlue
        })
    }
    onClick={() => onChange(tabId)}
  >
    {children}
  </div>;
};

export default memo(Tab);
